import PropTypes from 'prop-types';
import React from 'react';
import Validator from 'mixins/validator';
import Resetter from 'mixins/resetter';
import { Button } from 'react-toolbox';
import { connect } from 'react-redux';
import SignatureBox from 'components/SignatureBox';
import S from 'modal.scss';
import { getPhaseErrors } from '../../../../../../../../../reducers';

class LrrpSignature extends Resetter(Validator(React.Component)) {
  state = {
    signature: this.props.signature || '',
    clearSignature: 0,
    errors: {},
  };

  handleSubmit = () => {
    const checks = { signature: true };
    if (!this.validate(checks)) return;
    this.props.updateFormData({ signature: this.state.signature, tab: 3 });
  }

  handlePrevious = () => {
    this.props.updateFormData({
      signature: this.state.signature, tab: 1,
    });
  }

  handleSignature = data => this.setState({ signature: data });

  handleSignatureClear = () => {
    this.setState({
      signature: '',
      clearSignature: this.props.signature
        ? this.state.clearSignature : Date.now(),
    });
    this.props.updateFormData({ signature: '' });
  }

  render = () => {
    const { errors, clearSignature } = this.state;

    return (<div>
      <h6>Installer Certification</h6>
      <p className={S.legalText}>
        I, the undersigned installer, certify under penalty of law that the above information is
        true and complete, and do hereby certify that I have complied with all requirements of the
        Lead Renovation, Repair, and Painting Rule (RRP RULE), 40 § 745.80, et seq., or any
        applicable state laws or program regulating lead-based paint safe work practices, including
        compliance with all information distribution, notice requirements and work practice
        standards in performing this Renovation Project. I certify that I have provided the Customer
        with all documentation required to be supplied under the RRP Rule or state program, shall
        retain all records required by law for at least 3 years or longer if required by state law,
        and shall provide copies of all the records required to be retained by the RRP Rule or
        applicable state program upon request. If requested by the Customer, I have provided the
        Customer with a completed copy of this Renovation Recordkeeping Checklist.
      </p>
      <SignatureBox
        label="Sign Name *"
        required
        value={this.props.signature}
        errors={errors.signature}
        clearTimestamp={clearSignature}
        onEnd={this.handleSignature}
        onClear={this.handleSignatureClear}
      />
      <Button label="Submit" flat inverse ripple className={S.submit} onClick={this.handleSubmit} />
      <Button label="Previous" flat inverse ripple className={S.submit} onClick={this.handlePrevious} />
    </div>);
  }
}

LrrpSignature.propTypes = {
  signature: PropTypes.string,
  errors: PropTypes.shape({
    signature: PropTypes.arrayOf(PropTypes.string),
  }),
};

export default connect(state => ({ errors: getPhaseErrors(state) }), {
})(LrrpSignature);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/tasks/components/SignLrrpModal/lrrp_signature.jsx